// AUTO-GENERATED by backend/scripts/export_ws_events.py — do not edit by hand.
// Regenerate with: python backend/scripts/export_ws_events.py
export const WS_EVENT_TYPES = {
  agent_start: "agent_start",
  agent_update: "agent_update",
  agent_progress: "agent_progress",
  agent_complete: "agent_complete",
  build_start: "build_start",
  build_complete: "build_complete",
  build_failed: "build_failed",
  file_update: "file_update",
  error: "error",
  debug_start: "debug_start",
  stream_token: "stream_token",
  credits_update: "credits_update",
  agent_output: "agent_output",
  gate_request: "gate_request",
  gate_resolved: "gate_resolved",
} as const
